<h2>Órdenes</h2>
<!--Table-->
<div class="card">

  <form [formGroup]="filterForm" class="mb-4 gap-2 p-4 surface-card shadow-2 border-round">
    <div class="formgroup-inline">

      <div class="field col-12 xl:col-4 flex flex-column gap-2">
        <label for="accountId" class="block font-bold mb-2">Cuenta</label>
        <p-select id="accountId" [options]="accounts" formControlName="accountId" placeholder="Selecciona una Cuenta"
          optionLabel="name" [resetFilterOnHide]="true" [filter]="true" lazy="true"
          (onFilter)="loadAccounts($event)" (onChange)="onAccountChange()" [showClear]="false"
          optionValue="accountId" [disabled]="!hasAccountAccess" [loading]="accountLoading" [fluid]="true"
          [appendTo]="'body'">
        </p-select>
        @if (hasCreateAccess) {
          <button pButton type="button" label="Nueva Orden" icon="pi pi-plus" severity="primary"
            class="w-6" (click)="openCreateOrder()"></button>
        }
      </div>

    </div>
  </form>

  <p-popover #overlay [style]="{width:'300px'}">
    <div class="dropdown-header">
      <div class="dropdown-header-left">
        <p-checkbox [(ngModel)]="selectAll" binary="true" (onChange)="onSelectAll($event)">
        </p-checkbox>
        <input type="text" pInputText placeholder="Buscar Columna" [(ngModel)]="columnSearchTerm"
          class="column-search-input">
      </div>
      <button pButton icon="pi pi-times" (click)="overlay.hide()" class="p-button-rounded p-button-text">
      </button>
    </div>
    <br>
      <div class="columns-list mb-2" style="max-height:200px; overflow:auto;">
        @for (col of filteredColumns; track col) {
          <div>
            @if (!col.alwaysVisible) {
              <div class="field-checkbox">
                <p-checkbox [(ngModel)]="col.visible" binary="true" [inputId]="'col-' + col.field"
                  (onChange)="onColumnToggle()" />
                <label [for]="'col-' + col.field">{{ col.header }}</label>
              </div>
            }
          </div>
        }
      </div>
      <div class="footer flex justify-content-end gap-2">
        <button pButton label="Limpiar" severity="secondary" (click)="onClearColumns()"></button>
        <button pButton label="Guardar" (click)="onSaveColumns(); overlay.hide()"></button>
      </div>
  </p-popover>

  <p-table #dt [value]="orders" dataKey="orderId" [paginator]="true" [rows]="tableRows"
    [rowsPerPageOptions]="[30, 50, 100, 200]" [totalRecords]="totalRecords" [lazy]="true"
    (onLazyLoad)="loadOrders($event)" [loading]="loading" [responsiveLayout]="'scroll'" [(first)]="firstPage"
    [sortOrder]="-1" [defaultSortOrder]="-1" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords} Registros"
    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between mb-2">
        <div class="flex align-items-center gap-3">
          <span>Administrar Órdenes</span>
        </div>
        <div class="flex gap-2">
          <p-button icon="pi pi-filter-slash" severity="secondary" pTooltip="Limpiar Filtros y Orden"
            (click)="dt.clear()">
          </p-button>
          <p-button icon="pi pi-download" severity="secondary" pTooltip="Exportar"
            [loading]="exportLoading" [disabled]="!totalRecords" (click)="exportExcel()">
          </p-button>
          <p-button icon="pi pi-map" (click)="overlay.toggle($event); onColumnToggle()"
            pTooltip="Mostrar Columnas">
          </p-button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        @for (col of appliedTableColumns; track col) {
          <th [pSortableColumn]="col.sortable ? col.field : ''">
            <div class="flex align-items-center justify-content-between gap-2">
              <span>
                {{ col.header }}
                @if (col.sortable) {
                  <p-sortIcon [field]="col.field" />
                }
              </span>
              @switch (col.field) {
                @case ('orderId') {
                  <p-columnFilter field="orderId" matchMode="equals" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false" [showApplyButton]="false"
                    (onClear)="orderIdFilterText = ''">
                    <ng-template pTemplate="filter" let-filterCallback="filterCallback">
                      <div class="flex align-items-center gap-2">
                        <input pInputText type="text" [(ngModel)]="orderIdFilterText" placeholder="Ej. ENT-1045 o 1045"
                          (keydown.enter)="onOrderIdFilterChange(orderIdFilterText, filterCallback)">
                        <button pButton type="button" icon="pi pi-search" class="p-button-sm p-button-outlined"
                          pTooltip="Aplicar" (click)="onOrderIdFilterChange(orderIdFilterText, filterCallback)"></button>
                      </div>
                    </ng-template>
                  </p-columnFilter>
                }
                @case ('account.name') {
                  <p-columnFilter type="text" field="account.name" display="menu" matchMode="contains"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                    placeholder="Buscar Cuenta"></p-columnFilter>
                }
                @case ('orderType') {
                  <p-columnFilter field="orderType" matchMode="equals" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false">
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-select [ngModel]="value" [options]="orderTypeOptions" optionLabel="label" optionValue="value"
                        placeholder="Selecciona" [showClear]="true" [fluid]="true"
                        (onChange)="filterCallback($event.value)" (onClear)="filterCallback(null)"></p-select>
                    </ng-template>
                  </p-columnFilter>
                }
                @case ('platform') {
                  <p-columnFilter field="platform" matchMode="equals" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false">
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-select [ngModel]="value" [options]="platformOptions" placeholder="Selecciona"
                        [showClear]="true" [fluid]="true" (onChange)="filterCallback($event.value)"
                        (onClear)="filterCallback(null)"></p-select>
                    </ng-template>
                  </p-columnFilter>
                }
                @case ('productCount') {
                  <p-columnFilter type="numeric" field="productCount" display="menu" [showOperator]="false"
                    [showAddButton]="false" placeholder="Buscar Productos"></p-columnFilter>
                }
                @case ('totalArticles') {
                  <p-columnFilter type="numeric" field="totalArticles" display="menu" [showOperator]="false"
                    [showAddButton]="false" placeholder="Buscar Artículos"></p-columnFilter>
                }
                @case ('assignedUser.name') {
                  <p-columnFilter field="assignedUser.name" matchMode="equals" display="menu"
                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-select [ngModel]="value" [options]="assignableUsers" optionLabel="name" optionValue="userId"
                        placeholder="Selecciona" [showClear]="true" [fluid]="true"
                        (onChange)="filterCallback($event.value)" (onClear)="filterCallback(null)"></p-select>
                    </ng-template>
                  </p-columnFilter>
                }
                @case ('status') {
                  <p-columnFilter field="status" matchMode="equals" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false">
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-select [ngModel]="value" [options]="statusOptions" optionLabel="label" optionValue="value"
                        placeholder="Selecciona" [showClear]="true" [fluid]="true"
                        (onChange)="filterCallback($event.value)" (onClear)="filterCallback(null)"></p-select>
                    </ng-template>
                  </p-columnFilter>
                }
                @case ('creationDate') {
                  <p-columnFilter type="date" field="creationDate" display="menu"
                    placeholder="Filtrar por fecha"></p-columnFilter>
                }
                @case ('updateDate') {
                  <p-columnFilter type="date" field="updateDate" display="menu"
                    placeholder="Filtrar por fecha"></p-columnFilter>
                }
                @case ('scheduledDate') {
                  <p-columnFilter type="date" field="scheduledDate" display="menu"
                    placeholder="Filtrar por fecha"></p-columnFilter>
                }
                @case ('completedDate') {
                  <p-columnFilter type="date" field="completedDate" display="menu"
                    placeholder="Filtrar por fecha"></p-columnFilter>
                }
                @case ('verified') {
                  <p-columnFilter field="verified" matchMode="equals" display="menu" [showMatchModes]="false"
                    [showOperator]="false" [showAddButton]="false">
                    <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                      <p-select [ngModel]="value" [options]="verifiedOptions" optionLabel="label" optionValue="value"
                        placeholder="Selecciona" [showClear]="true" [fluid]="true"
                        (onChange)="filterCallback($event.value)" (onClear)="filterCallback(null)"></p-select>
                    </ng-template>
                  </p-columnFilter>
                }
              }
            </div>
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order let-rowIndex="rowIndex">
      <tr>
        @for (col of appliedTableColumns; track col) {
          <td>
            @switch (col.type) {
              <!-- Number / row index -->
              @case ('number') {
                <span>
                  @if (col.field === 'rowIndex') {
                    {{ rowIndex + 1 }}
                  } @else if (col.field === 'orderId') {
                    {{ getOrderCode(order) }}
                  } @else {
                    {{ resolveField(order, col.field) }}
                  }
                </span>
              }
              <!-- String -->
              @case ('string') {
                @if (col.field === 'platform') {
                  @if (getPlatformLogo(order.platform); as logo) {
                    <img [src]="logo" [alt]="order.platform" [pTooltip]="order.platform" class="platform-logo">
                  } @else {
                    <span>{{ order.platform }}</span>
                  }
                } @else if (col.field === 'assignedUser.name') {
                  @if (order.assignedUser) {
                    <div class="flex flex-column">
                      <span>{{ order.assignedUser.name }} {{ order.assignedUser.lastname }}</span>
                      <span class="text-color-secondary text-sm">{{ order.assignedUser.email }}</span>
                    </div>
                  } @else {
                    <span class="text-color-secondary">Sin asignar</span>
                  }
                } @else {
                  <span>{{ resolveField(order, col.field) ?? '—' }}</span>
                }
              }
              <!-- Date -->
              @case ('date') {
                <span>
                  {{ resolveField(order, col.field) | date:'dd/MMM/yyyy h:mm a' }}
                </span>
              }
              <!-- Tag (Estado / Tipo de Orden / Verificada) -->
              @case ('tag') {
                @if (col.field === 'orderType') {
                  <p-tag [value]="getOrderTypeLabel(order)" [severity]="getOrderTypeSeverity(order)"
                    [icon]="getOrderTypeIcon(order)"></p-tag>
                } @else if (col.field === 'verified') {
                  <p-tag [value]="getVerifiedLabel(order)" [severity]="getVerifiedSeverity(order)"></p-tag>
                } @else {
                  <p-tag [value]="getStatusLabel(order)" [severity]="getStatusSeverity(order)"></p-tag>
                }
              }
              <!-- Actions -->
              @case ('actions') {
                <span>
                  <div class="flex gap-2 justify-content-center">
                    <button pButton icon="pi pi-eye" severity="primary" class="p-button-rounded p-button-xs"
                      pTooltip="Ver Detalles" (click)="openViewDetails(order)"
                      style="width: 30px; height: 30px; padding: 0;">
                    </button>
                    @if (canCancelOrder(order)) {
                      <button pButton icon="pi pi-ban" severity="danger" class="p-button-rounded p-button-xs"
                        pTooltip="Cancelar Orden" (click)="openCancelDialog(order)"
                        style="width: 30px; height: 30px; padding: 0;">
                      </button>
                    }
                  </div>
                </span>
              }
            }
          </td>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="appliedTableColumns.length" class="text-center p-4">
          No se encontraron órdenes para los filtros seleccionados.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- View details dialog: order info (with Jira-style click-to-edit on the v1-agreed
     fields) + items + history, mirrors the approved mockup (attachments/"Procesados"/
     Comentarios/Servicios tabs are future-phase features tied to the not-yet-built
     entrada/salida process — intentionally left out here). Asignado is always read-only:
     it's set by the system/elsewhere, not edited by hand here. -->
<p-dialog header="Detalles de Orden — {{ viewingOrder ? getOrderCode(viewingOrder) : '' }}" [(visible)]="viewDialogVisible"
  [style]="{width: '920px'}" [modal]="true" contentStyleClass="movements-dialog-content">
  @if (viewLoading) {
    <div class="flex justify-content-center p-5">
      <p-progressSpinner styleClass="w-3rem h-3rem"></p-progressSpinner>
    </div>
  } @else if (viewingOrder) {
    <div class="movements-scroll">
      <div class="flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <div class="flex align-items-center gap-2 flex-wrap">
          <p-tag [value]="getOrderTypeLabel(viewingOrder)" [severity]="getOrderTypeSeverity(viewingOrder)"
            [icon]="getOrderTypeIcon(viewingOrder)"></p-tag>
          <span class="text-color-secondary">{{ viewingOrder.account?.name }}</span>
        </div>
        <p-tag [value]="getStatusLabel(viewingOrder)" [severity]="getStatusSeverity(viewingOrder)"
          [icon]="getStatusIcon(viewingOrder)" styleClass="order-status-tag"></p-tag>
      </div>

      <div class="details-panel mb-4">
        <button type="button" class="details-toggle" (click)="detailsExpanded = !detailsExpanded">
          <i class="pi" [ngClass]="detailsExpanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          <span>Información general</span>
        </button>

        @if (detailsExpanded) {
          <div class="details-grid" [formGroup]="viewForm">
            <div class="details-columns">

              <!-- Left column: order data -->
              <div class="details-column">

                <!-- Fecha -->
                <div class="details-row">
                  <div class="details-label">Fecha</div>
                  <div class="details-value">
                    @if (editingField === 'scheduledDate') {
                      <span class="inline-edit">
                        <p-datepicker formControlName="scheduledDate" [showTime]="true" [hourFormat]="'12'"
                          [showIcon]="true" iconDisplay="input" [appendTo]="'body'"></p-datepicker>
                        <button pButton icon="pi pi-check" severity="primary" class="p-button-rounded p-button-text p-button-sm"
                          [loading]="savingField" (click)="confirmEditField('scheduledDate')"></button>
                        <button pButton icon="pi pi-times" severity="secondary" class="p-button-rounded p-button-text p-button-sm"
                          [disabled]="savingField" (click)="cancelEditField('scheduledDate')"></button>
                      </span>
                    } @else {
                      <span>{{ viewForm.get('scheduledDate')?.value | date:'dd/MMM/yyyy h:mm a' }}</span>
                      @if (canEditFields) {
                        <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
                          (click)="startEditField('scheduledDate')"></button>
                      }
                    }
                  </div>
                </div>

                <!-- Titular -->
                <div class="details-row">
                  <div class="details-label">Titular</div>
                  <div class="details-value">
                    @if (editingField === 'titular') {
                      <span class="inline-edit">
                        <input pInputText formControlName="titular" class="inline-edit-input">
                        <button pButton icon="pi pi-check" severity="primary" class="p-button-rounded p-button-text p-button-sm"
                          [loading]="savingField" (click)="confirmEditField('titular')"></button>
                        <button pButton icon="pi pi-times" severity="secondary" class="p-button-rounded p-button-text p-button-sm"
                          [disabled]="savingField" (click)="cancelEditField('titular')"></button>
                      </span>
                    } @else {
                      <span>{{ viewForm.get('titular')?.value || '—' }}</span>
                      @if (canEditFields) {
                        <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
                          (click)="startEditField('titular')"></button>
                      }
                    }
                  </div>
                </div>

                <!-- Ubicación (+ Dirección) -->
                <div class="details-row">
                  <div class="details-label">Ubicación</div>
                  <div class="details-value">
                    @if (editingField === 'location') {
                      <span class="inline-edit flex-column align-items-stretch">
                        <p-selectButton formControlName="location" [options]="locationOptions" optionLabel="label"
                          optionValue="value" [fluid]="true"></p-selectButton>
                        @if (viewForm.get('location')?.value === 'DOMICILIO') {
                          <textarea pTextarea formControlName="address" rows="2" class="w-full mt-2"
                            placeholder="Dirección"></textarea>
                        }
                        <div class="details-actions-row mt-2">
                          <button pButton icon="pi pi-check" label="Listo" severity="primary"
                            class="p-button-sm" [loading]="savingField" (click)="confirmEditField('location')"></button>
                          <button pButton icon="pi pi-times" label="Cancelar" severity="secondary" [outlined]="true"
                            class="p-button-sm" [disabled]="savingField" (click)="cancelEditField('location')"></button>
                        </div>
                      </span>
                    } @else {
                      <span>
                        {{ viewForm.get('location')?.value === 'DOMICILIO' ? (viewForm.get('address')?.value || 'Domicilio') : 'Bodega' }}
                      </span>
                      @if (canEditFields) {
                        <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
                          (click)="startEditField('location')"></button>
                      }
                    }
                  </div>
                </div>

                <!-- Plataforma -->
                <div class="details-row">
                  <div class="details-label">Plataforma</div>
                  <div class="details-value">
                    @if (editingField === 'platform') {
                      <span class="inline-edit">
                        <p-select formControlName="platform" [options]="platformOptions" [filter]="true"
                          [appendTo]="'body'"></p-select>
                        <button pButton icon="pi pi-check" severity="primary" class="p-button-rounded p-button-text p-button-sm"
                          [loading]="savingField" (click)="confirmEditField('platform')"></button>
                        <button pButton icon="pi pi-times" severity="secondary" class="p-button-rounded p-button-text p-button-sm"
                          [disabled]="savingField" (click)="cancelEditField('platform')"></button>
                      </span>
                    } @else {
                      @if (getPlatformLogo(viewForm.get('platform')?.value); as logo) {
                        <img [src]="logo" [alt]="viewForm.get('platform')?.value" class="platform-logo">
                      } @else {
                        <span>{{ viewForm.get('platform')?.value }}</span>
                      }
                      @if (canEditFields) {
                        <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
                          (click)="startEditField('platform')"></button>
                      }
                    }
                  </div>
                </div>

                <!-- Descripción -->
                <div class="details-row">
                  <div class="details-label">Descripción</div>
                  <div class="details-value">
                    @if (editingField === 'description') {
                      <span class="inline-edit flex-column align-items-stretch">
                        <textarea pTextarea formControlName="description" rows="2" class="w-full"></textarea>
                        <div class="details-actions-row mt-2">
                          <button pButton icon="pi pi-check" label="Listo" severity="primary"
                            class="p-button-sm" [loading]="savingField" (click)="confirmEditField('description')"></button>
                          <button pButton icon="pi pi-times" label="Cancelar" severity="secondary" [outlined]="true"
                            class="p-button-sm" [disabled]="savingField" (click)="cancelEditField('description')"></button>
                        </div>
                      </span>
                    } @else {
                      <span>{{ viewForm.get('description')?.value || '—' }}</span>
                      @if (canEditFields) {
                        <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
                          (click)="startEditField('description')"></button>
                      }
                    }
                  </div>
                </div>
              </div>

              <!-- Right column: assignment + lifecycle timestamps -->
              <div class="details-column">

                <!-- Asignado: BILD-only edit — a client may never touch this field. -->
                <div class="details-row">
                  <div class="details-label">Asignado</div>
                  <div class="details-value">
                    @if (editingField === 'assignedUserId') {
                      <span class="inline-edit flex-column align-items-stretch">
                        <p-select formControlName="assignedUserId" [options]="assignableUserOptions"
                          optionLabel="fullName" optionValue="userId" [filter]="true" [showClear]="true"
                          placeholder="Sin asignar" [fluid]="true" [appendTo]="'body'"></p-select>
                        <div class="details-actions-row mt-2">
                          <button pButton type="button" label="Asignarme" icon="pi pi-user" severity="secondary"
                            [outlined]="true" class="p-button-sm" [disabled]="savingAssignment"
                            (click)="assignToMe()"></button>
                          <button pButton icon="pi pi-check" label="Listo" severity="primary"
                            class="p-button-sm" [loading]="savingAssignment" (click)="confirmEditField('assignedUserId')"></button>
                          <button pButton icon="pi pi-times" label="Cancelar" severity="secondary" [outlined]="true"
                            class="p-button-sm" [disabled]="savingAssignment" (click)="cancelEditField('assignedUserId')"></button>
                        </div>
                      </span>
                    } @else {
                      @if (getAssignedUserDisplay(); as assignee) {
                        <span class="assignee-chip">
                          <p-avatar [label]="getInitials(assignee.name, assignee.lastname)" shape="circle"></p-avatar>
                          <span>{{ assignee.name }} {{ assignee.lastname }}</span>
                        </span>
                      } @else {
                        <span class="text-color-secondary">Sin asignar</span>
                      }
                      @if (canEditAssignee) {
                        <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
                          (click)="startEditField('assignedUserId')"></button>
                      }
                    }
                  </div>
                </div>

                <div class="details-row">
                  <div class="details-label">Creada</div>
                  <div class="details-value">{{ viewingOrder.creationDate | date:'dd/MMM/yyyy h:mm a' }}</div>
                </div>
                <div class="details-row">
                  <div class="details-label">Actualizada</div>
                  <div class="details-value">{{ viewingOrder.updateDate ? (viewingOrder.updateDate | date:'dd/MMM/yyyy h:mm a') : '—' }}</div>
                </div>
                <div class="details-row">
                  <div class="details-label">Verificada</div>
                  <div class="details-value">
                    <p-tag [value]="getVerifiedLabel(viewingOrder)" [severity]="getVerifiedSeverity(viewingOrder)"></p-tag>
                  </div>
                </div>
                <div class="details-row">
                  <div class="details-label">Completada</div>
                  <div class="details-value">{{ viewingOrder.completedDate ? (viewingOrder.completedDate | date:'dd/MMM/yyyy h:mm a') : '—' }}</div>
                </div>
              </div>

            </div>
          </div>
        }
      </div>

      @if (hasEditAccess && hasPendingChanges) {
        <div class="pending-changes-bar mb-3">
          <div class="flex align-items-center gap-2 mb-2">
            <i class="pi pi-exclamation-circle text-yellow-600"></i>
            <strong>Tienes cambios sin guardar</strong>
          </div>
          <textarea pTextarea [(ngModel)]="saveComment" [ngModelOptions]="{standalone: true}" rows="2"
            class="w-full mb-2" placeholder="Explica el motivo del cambio (obligatorio)"></textarea>
          <div class="flex justify-content-end gap-2">
            <button pButton type="button" label="Descartar" severity="secondary" [outlined]="true"
              (click)="discardViewChanges()"></button>
            <button pButton type="button" label="Guardar cambios" icon="pi pi-check" [loading]="savingChanges"
              [disabled]="!saveComment.trim()" (click)="saveViewChanges()"></button>
          </div>
        </div>
      }

      @if (!editingItems) {
        <div class="items-summary flex align-items-center justify-content-between flex-wrap gap-2">
          <div class="flex align-items-center gap-3 flex-wrap">
            <span><strong>Productos:</strong> {{ viewingOrder.productCount }}</span>
            <span><strong>Artículos:</strong> {{ viewingOrder.totalArticles }}</span>
          </div>
          @if (canEditFields) {
            <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
              pTooltip="Editar productos" (click)="startEditItems()"></button>
          }
        </div>
        <p-table [value]="viewingOrder.items ?? []" dataKey="orderItemId" styleClass="p-datatable-sm p-datatable-gridlines mb-4">
          <ng-template pTemplate="header">
            <tr>
              <th>#</th>
              <th>SKU</th>
              <th>Descripción</th>
              <th>Variante</th>
              <th>Cantidad</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
            <tr>
              <td>{{ rowIndex + 1 }}</td>
              <td>{{ item.sku }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.variant }}</td>
              <td>{{ item.quantity }}</td>
              <td>
                <button pButton icon="pi pi-comment" class="p-button-rounded p-button-text"
                  [severity]="item.comments ? 'info' : 'secondary'" pTooltip="Notas"
                  (click)="openViewCommentPopover($event, item, viewItemCommentPopover)"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <p-popover #viewItemCommentPopover [style]="{width: '420px'}">
          @if (activeViewCommentItem) {
            <label class="block font-bold mb-2">Notas — {{ activeViewCommentItem.sku }}</label>
            @if (activeViewCommentItem.comments) {
              <div [innerHTML]="activeViewCommentItem.comments"></div>
            } @else {
              <span class="text-color-secondary">Sin notas.</span>
            }
          }
        </p-popover>
      } @else {
        <div class="items-edit-panel mb-4">
          @if (itemsStockWarning) {
            <p-message severity="warn" styleClass="w-full mb-3">{{ itemsStockWarning }}</p-message>
          }
          <div class="grid">
            <div class="col-12">
              <div class="wizard-panel">
                <h4 class="mt-0"><span class="panel-icon"><i class="pi pi-th-large"></i></span>Catálogo — {{ viewingOrder.account?.name }}</h4>
                <input pInputText class="w-full mb-3" placeholder="Buscar por SKU, Descripción o UPC"
                  [ngModel]="itemsCatalogSearchTerm" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onItemsCatalogSearch($event)">
                <p-table [value]="itemsCatalogProducts" dataKey="productId" [lazy]="true"
                  (onLazyLoad)="loadItemsCatalog($event)" [paginator]="true" [rows]="itemsCatalogRows"
                  [totalRecords]="itemsCatalogTotalRecords" [loading]="itemsCatalogLoading"
                  styleClass="p-datatable-sm p-datatable-gridlines">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>SKU</th>
                      <th>Descripción</th>
                      <th>Variante</th>
                      <th>En Stock</th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-product>
                    <tr>
                      <td>{{ product.sku }}</td>
                      <td>{{ product.description }}</td>
                      <td>{{ product.variant }}</td>
                      <td>{{ product.availableQuantity }}</td>
                      <td>
                        <button pButton icon="pi pi-plus" class="p-button-rounded p-button-sm"
                          pTooltip="Agregar" [disabled]="!canAddItemToCart(product)"
                          (click)="addItemToCart(product)"></button>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="5" class="text-center p-3">No se encontraron productos.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>

            <div class="col-12">
              <div class="wizard-panel">
                <h4 class="mt-0 flex align-items-center gap-2 flex-wrap">
                  <span class="panel-icon"><i class="pi pi-shopping-cart"></i></span>
                  <span>Productos seleccionados ({{ itemsDraft.length }})</span>
                  <p-tag [value]="'Total: ' + itemsTotalQuantity + ' artículos'" severity="info"></p-tag>
                </h4>
                <p-table [value]="itemsDraft" dataKey="productId" styleClass="p-datatable-sm p-datatable-gridlines">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>#</th>
                      <th>SKU</th>
                      <th>Descripción</th>
                      <th>Variante</th>
                      <th>En Stock</th>
                      <th>Cantidad</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                    <tr [class.insufficient-row]="item.insufficientStock">
                      <td>{{ rowIndex + 1 }}</td>
                      <td>{{ item.sku }}</td>
                      <td>{{ item.description }}</td>
                      <td>{{ item.variant }}</td>
                      <td>{{ item.availableQuantity }}</td>
                      <td>
                        <p-inputNumber [(ngModel)]="item.quantity" [ngModelOptions]="{standalone: true}" [min]="1"
                          [max]="viewingOrder.orderType === 'ENTREGA' ? item.availableQuantity : undefined"
                          [invalid]="item.insufficientStock" (ngModelChange)="item.insufficientStock = false"
                          inputStyleClass="w-full" [showButtons]="true"></p-inputNumber>
                        @if (item.insufficientStock) {
                          <small class="p-error block">Solo hay {{ item.availableQuantity }} disponibles</small>
                        }
                      </td>
                      <td>
                        <button pButton icon="pi pi-comment" class="p-button-rounded p-button-text"
                          [severity]="item.comments ? 'info' : 'secondary'" pTooltip="Notas"
                          (click)="openItemCommentPopover($event, item, itemCommentPopover)"></button>
                      </td>
                      <td>
                        <button pButton icon="pi pi-trash" severity="danger" class="p-button-rounded p-button-text"
                          pTooltip="Quitar" (click)="removeItemFromCart(item)"></button>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="8" class="text-center p-3">Agrega productos desde el catálogo.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>

          <p-popover #itemCommentPopover [style]="{width: '420px'}">
            @if (activeItemCommentItem) {
              <label class="block font-bold mb-2">Notas — {{ activeItemCommentItem.sku }}</label>
              <p-editor [(ngModel)]="activeItemCommentItem.comments" [ngModelOptions]="{standalone: true}"
                [style]="{height: '180px'}">
                <ng-template pTemplate="header">
                  <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold" type="button"></button>
                    <button class="ql-italic" aria-label="Italic" type="button"></button>
                    <button class="ql-underline" aria-label="Underline" type="button"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
                    <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-link" aria-label="Insert Link" type="button"></button>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
                  </span>
                </ng-template>
              </p-editor>
            }
          </p-popover>

          <div class="details-actions-row mt-3">
            <button pButton icon="pi pi-check" label="Listo" severity="primary" class="p-button-sm"
              [loading]="savingItems" (click)="confirmEditItems()"></button>
            <button pButton icon="pi pi-times" label="Cancelar" severity="secondary" [outlined]="true"
              class="p-button-sm" [disabled]="savingItems" (click)="cancelEditItems()"></button>
          </div>
        </div>
      }

      <h4 class="mb-3">Actividad</h4>
      <div class="activity-tabs mb-3">
        <button type="button" class="activity-tab" [class.activity-tab-active]="activityTab === 'comments'"
          (click)="activityTab = 'comments'">Comentarios</button>
        <button type="button" class="activity-tab" [class.activity-tab-active]="activityTab === 'history'"
          (click)="activityTab = 'history'">Historial</button>
      </div>

      @if (activityTab === 'comments') {
        @if (hasEditAccess) {
          <div class="comment-composer-row mb-3">
            <p-avatar [label]="currentUserInitials" shape="circle" styleClass="comment-avatar"></p-avatar>
            <div class="flex-1">
              @if (!composerExpanded) {
                <div class="comment-placeholder" (click)="composerExpanded = true">Agregar un comentario...</div>
              } @else {
                <p-editor [(ngModel)]="newComment" [style]="{height: '140px'}">
                  <ng-template pTemplate="header">
                    <span class="ql-formats">
                      <button class="ql-bold" aria-label="Bold" type="button"></button>
                      <button class="ql-italic" aria-label="Italic" type="button"></button>
                      <button class="ql-underline" aria-label="Underline" type="button"></button>
                    </span>
                    <span class="ql-formats">
                      <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
                      <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
                    </span>
                    <span class="ql-formats">
                      <button class="ql-link" aria-label="Insert Link" type="button"></button>
                    </span>
                    <span class="ql-formats">
                      <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
                    </span>
                  </ng-template>
                </p-editor>
                <div class="flex justify-content-end gap-2 mt-2">
                  <button pButton type="button" label="Cancelar" severity="secondary" [outlined]="true"
                    (click)="cancelComposer()"></button>
                  <button pButton type="button" label="Comentar" icon="pi pi-send" [loading]="postingComment"
                    [disabled]="!newComment.trim()" (click)="submitComment()"></button>
                </div>
              }
            </div>
          </div>
        }
        @if (!commentMovements.length) {
          <p class="text-color-secondary">Aún no hay comentarios.</p>
        }
        @for (comment of commentMovements; track comment.orderMovementId) {
          <div class="comment-card mb-2">
            <div class="comment-card-header">
              <strong>{{ comment.user }}</strong>
              <small class="text-surface-500 dark:text-surface-400">{{ comment.movementTime | date:'dd/MMM/yyyy h:mm a' }}</small>
            </div>
            <div class="comment-card-body" [innerHTML]="comment.movementReason"></div>
          </div>
        }
      } @else {
        <p-timeline [value]="historyMovements" align="left" styleClass="movements-timeline">
          <ng-template pTemplate="marker" let-movement>
            <span class="movement-marker"
              [ngClass]="movement.movementType === 'CREATE' ? 'movement-marker-create' : 'movement-marker-update'">
              <i class="pi" [ngClass]="movement.movementType === 'CREATE' ? 'pi-plus' : 'pi-pencil'"></i>
            </span>
          </ng-template>

          <ng-template pTemplate="content" let-movement>
            <div class="movement-card">
              <div class="movement-card-header">
                <span class="movement-title">
                  @if (movement.movementType === 'CREATE') {
                    Orden creada
                  }
                  @if (movement.movementType === 'UPDATE') {
                    Edición
                  }
                </span>
                <small class="text-surface-500 dark:text-surface-400">{{ movement.movementTime | date:'dd/MMM/yyyy h:mm a' }}</small>
              </div>

              @if (movement.movementType === 'UPDATE' && movement.changeDetail) {
                <div class="movement-card-body">
                  @for (field of movement.changeDetail | keyvalue; track field) {
                    <div class="movement-change">
                      <span class="movement-change-label">{{ getFieldLabel($any(field.key)) }}:</span>
                      @if (field.key === 'closeReason') {
                        <span class="movement-change-value">{{ getFieldValue($any(field.value)?.new) }}</span>
                      } @else {
                        <span class="movement-change-value">"{{ getFieldValue($any(field.value)?.old)
                        }}" → "{{ getFieldValue($any(field.value)?.new) }}"</span>
                      }
                    </div>
                  }
                </div>
              }

              <div class="movement-card-footer">
                <small class="text-surface-500 dark:text-surface-400">por {{ movement.user }}</small>
                @if (movement.movementReason) {
                  <div class="movement-reason">
                    <i><strong>Nota: </strong>{{ movement.movementReason }}</i>
                  </div>
                }
              </div>
            </div>
          </ng-template>
        </p-timeline>
      }
    </div>
  }

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cerrar" (click)="viewDialogVisible = false"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Cancelar Orden{{ cancelingOrder ? ' — ' + getOrderCode(cancelingOrder) : '' }}"
  [(visible)]="cancelDialogVisible" [style]="{width: '480px'}" [modal]="true" (onHide)="closeCancelDialog()">
  <p class="mt-0">
    Esta acción cierra la orden y libera los productos/artículos que tenía reservados. No se puede deshacer.
  </p>
  <label class="block font-bold mb-2">Motivo de cancelación</label>
  <textarea pTextarea [(ngModel)]="cancelComment" [ngModelOptions]="{standalone: true}" rows="3"
    class="w-full" placeholder="Explica por qué se cancela la orden (obligatorio)"></textarea>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Volver" severity="secondary" [outlined]="true"
      (click)="closeCancelDialog()"></button>
    <button pButton type="button" label="Cancelar Orden" severity="danger" icon="pi pi-ban"
      [loading]="cancelingOrderLoading" [disabled]="!cancelComment.trim()" (click)="confirmCancelOrder()"></button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
